import App from "../app";
import { ListItem } from "../model/datasource/list";
import { AttemptId, ProductId, ItemId, QuizId } from "../model/datasource";

export type MultipleChoiceAnswer = string;
export type MultipleCorrectAnswer = string[];
export type NumericAnswer = string;
export type ClozeAnswer = Record<string, string>;
export type MatchingAnswer = number[];
export type SortingAnswer = number[];
export type ConstructedResponseAnswer = string;
export type UnknownAnswer = undefined;

export type AnswerType = MultipleChoiceAnswer
	| MultipleCorrectAnswer
	| NumericAnswer
	| ClozeAnswer
	| MatchingAnswer
	| SortingAnswer
	| ConstructedResponseAnswer
	| UnknownAnswer;

export interface Annotations {
	answer?: AnswerType;
	flagged?: boolean;
}

export default class UserData<P extends ProductId, A extends AttemptId, Z extends QuizId, I extends ItemId> {
	app: App<P, A, Z, I>;
	product: P;
	attempt: A;
	userdata: Record<number, Annotations>;

	constructor() {
		this.userdata = {};
	}

	init(product: P, attempt: A, items: ListItem<I>[], app: App<P, A, Z, I>): void {
		this.product = product;
		this.app = app;
		this.attempt = attempt;
		this.userdata = items.reduce((result, item, index) => {
			const annotations = this._parse(item);
			if (Object.keys(annotations).length) {
				result[index] = annotations;
			}
			return result;
		}, {});
	}

	_parse(item: ListItem<I>): Annotations {
		const annotations: Annotations = {};
		if (typeof (item.answer) !== 'undefined') {
			annotations.answer = item.answer;
		}
		if (typeof (item.flagged) !== 'undefined') {
			annotations.flagged = item.flagged;
		}
		return annotations;
	}

	get(index: number): Annotations | null {
		return index in this.userdata ?
			this.userdata[index] :
			null;
	}

	set(index: number, id: I, data: Annotations): Annotations {
		this.userdata[index] = { ...(this.get(index) || {}), ...data };
		return this.userdata[index];
	}

	count(filter: (data: Annotations) => boolean = () => true): number {
		return Object.keys(this.userdata)
			.filter(key => this.userdata[key])
			.filter(key => filter(this.userdata[key]))
			.length;
	}
}
